import './free_text_attribute_view.js.coffee'

class Customer.IntegerAttributeView extends Customer.FreeTextAttributeView
  valueTemplate: JST['backbone/templates/customer/custom_attributes/values/integer']

  afterRender: ->

  getValues: ({additionalValueSelector, inputSelector, validationRequired}) =>
    rawValues = super
      additionalValueSelector: additionalValueSelector
      inputSelector: inputSelector
      validationRequired: validationRequired

    definition_code: rawValues.definition_code
    values: rawValues.values = _.map(rawValues.values, (value) -> parseInt(value))

  getErrorMessages: (_event) ->
    [@_invalidValueErrorMessage()]

  _invalidValueErrorMessage: ->
    I18n.t('monitoring.conversation_attributes.errors.integer.length')
